import { appConfig } from '../config/app-config'

export const isValidFTSS3Bucket = (url: string) => {
    return url.includes(
        appConfig.buildEnvironment === 'production'
            ? 'https://fts-private-data.s3.ap-south-1.amazonaws.com'
            : 'https://fts-private-data-test.s3.ap-south-1.amazonaws.com'
    )
}
